// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"233c92b8","396":"35ea91a5","455":"adec5a16","857":"dc1958c3","977":"8d83bd14"}[chunkId] + ".chunk.js";
};